const TARGETING_TYPES = {
    ALL: 'ALL',
    INCLUDE: 'INCLUDE',
    EXCLUDE: 'EXCLUDE',
};
export const INCLUDE_EXCLUDE_OPTIONS = [{ value: TARGETING_TYPES.INCLUDE }, { value: TARGETING_TYPES.EXCLUDE }];

export default TARGETING_TYPES;
